<template>
  <section>
    <v-layout row style="width: 88%;margin: auto;">
      <v-data-table :headers="headers"
                    :items="GetOffers"
                    item-key="Offer_Name"
                    class="elevation-1"
                    style="width:100%;">
        <template v-slot:headers="props">
          <tr>
            <th v-for="header in props.headers" :key="header.text"> {{ header.text }}</th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-center">{{ props.item.Offer_Name }}</td>
            <td class="text-xs-center">{{ props.item.Offer_Type }}</td>
            <td class="text-xs-center">{{ new Date(props.item.Start_Date).toDateString() }}</td>
            <td class="text-xs-center">{{ new Date(props.item.End_Date).toDateString() }}</td>
            <td class="text-xs-center">{{ props.item.Enable }}</td>
            <td class="text-xs-center">{{ props.item.Homepage_Visibility }}</td>
            <td class="text-xs-center">
              <!-- <v-icon color="primary" class="btnAction" v-if="props.item.Offer_Type == 'User'" @click="AddUserDialog(props.item)">group_add</v-icon>
              <v-icon color="primary" dark class="btnAction" @click="OpenUpdateDialog(props.item)">edit</v-icon> -->
                <v-btn color="primary" icon class="btnAction" v-if="props.item.Offer_Type == 'User'" @click="AddUserDialog(props.item)">
                  <v-icon>group_add</v-icon>
                </v-btn>
                <v-btn color="primary" icon class="btnAction" @click="OpenUpdateDialog(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn color="error" icon class="btnAction" @click="RemoveOffer(props.item)">
                  <v-icon>delete</v-icon>
                </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-layout>
    <app-add-user ref="SetUserOffer" :dialog="AddUser" @close="CloseDialog"></app-add-user>
    <app-promotional ref="Promotional" :dialog="Promotional" @close="CloseDialog"></app-promotional>
    <app-course-wise ref="CourseBased" :dialog="Course_Based" @close="CloseDialog"></app-course-wise>
    <app-user-based ref="UserBased" :dialog="User_Based" @close="CloseDialog"></app-user-based>
    <app-purchase ref="PurchaseBased" :dialog="Purchase_Based" @close="CloseDialog"></app-purchase>
    <app-buy-one-get-one ref="BuyOneGetOne" :dialog="BuyOne_GetOne" @close="CloseDialog"></app-buy-one-get-one>
  </section>
</template>
<script>
import appAddUser from "../dialogs/Offers/AddUser";
import appPromotional from "../dialogs/Offers/Promotional";
import appCourseWise from "../dialogs/Offers/CourseWise";
import appUserBased from "../dialogs/Offers/UserBased";
import appPurchase from "../dialogs/Offers/PurchaseBased";
import appBuyOneGetOne  from '../dialogs/Offers/BuyOnegetOne'

export default {
  components: {
    appAddUser,
    appPromotional,
    appCourseWise,
    appUserBased,
    appPurchase,
    appBuyOneGetOne
  },
  data() {
    return {
      headers        : [
                        { text: "Offer Name", value: "Offer_Name" },
                        { text: "Offer Type", value: "Offer_Type" },
                        { text: "Start Date", value: "Start_Date" },
                        { text: "End Date", value: "End_Date" },
                        { text: "Active", value: "Enable" },
                        { text: "Homepage Visible" , value :"Homepage_Visibility"},
                        { text: "Actions" }
                       ],
      AddUser        : false,
      Promotional    : false,
      Course_Based   : false,
      User_Based     : false,
      CashBack       : false,
      Purchase_Based : false,
      BuyOne_GetOne  : false
    };
  },
  computed: {
    GetOffers() {
      return this.$store.getters.GetOffers;
    }
  },
  methods: {
    AddUserDialog(Offer) {

      this.$refs.SetUserOffer.SetCurrentOffer(Offer);
      this.AddUser = true;
    },
    OpenUpdateDialog(Offer) {
      if ( Offer["Offer_Type"] == "Cashback" || Offer["Offer_Type"] == "Promotional" ) {

        this.$refs.Promotional.UpdateCurrentDetails(Offer);
        this.Promotional = true;

      } else if (Offer["Offer_Type"] == "Purchase") {

        this.$refs.PurchaseBased.UpdateCurrentDetails(Offer);
        this.Purchase_Based = true;

      } else if (Offer["Offer_Type"] == "Coursewise") {

        this.$refs.CourseBased.UpdateCurrentDetails(Offer);
        this.Course_Based = true;

      } else if (Offer["Offer_Type"] == "User") {

        this.$refs.UserBased.UpdateCurrentDetails(Offer);
        this.User_Based = true;

      }else if(Offer["Offer_Type"] == "BuyOneGetOne"){

        this.$refs.BuyOneGetOne.UpdateCurrentDetails(Offer);
        this.BuyOne_GetOne = true;

      }
    },
    CloseDialog() {

      this.AddUser         = false;
      this.Promotional     = false;
      this.Course_Based    = false;
      this.User_Based      = false;
      this.CashBack        = false;
      this.Purchase_Based  = false;
      this.BuyOne_GetOne   = false;

    },
    RemoveOffer(Offer){
      if (confirm("Do you really want to delete?")) {
       let data = { "Offer_Id" :Offer['_id']}
          this.$http.post(`${this.$store.getters.GetProductionUrl}/offers/removeoffer`)
              .then(response => {

                this.$store.commit("DeleteIndividualOffers", response["data"]["response"]);
              })
              .catch(err => {

                this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error While Fetching Data", Color: "red", Close: false });
              });
      }
    }
  },
  mounted() {

    this.$store.commit("SetLoading", true);
    this.$http.post(`${this.$store.getters.GetProductionUrl}/offers/getoffers`)
              .then(response => {

                this.$store.commit("SetOffers", response["data"]["response"]);
                this.$store.commit("SetLoading", false);

              })
              .catch(err => {

                this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error While Fetching Data", Color: "red", Close: false });
              });
  }
};
</script>
<style>
.btnAction {
  margin: 4px;
  border: 1px solid #d3d3d37a;
}
</style>


